import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { sendHoverSoundCommand, sendSelectClickSoundCommand } from '../../helpers/web_to_client'

import styles from './VehicleFilterCheckbox.scss'

const propTypes = {
    isChecked: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
}

const defaultProps = {
    isChecked: false,
    onChange: () => {},
}

class VehicleFilterCheckbox extends React.PureComponent {
    render() {
        const classNameBase = classNames(styles.base, {
            [styles.base__isChecked]: this.props.isChecked,
        })

        return (
            <label
                className={classNameBase}
                onMouseDown={sendSelectClickSoundCommand}
                onMouseEnter={sendHoverSoundCommand}
            >
                <input
                    type="checkbox"
                    className={styles.input}
                    checked={this.props.isChecked}
                    onChange={this.props.onChange}
                />
                <span className={styles.check} />
            </label>
        )
    }
}

VehicleFilterCheckbox.propTypes = propTypes
VehicleFilterCheckbox.defaultProps = defaultProps

export default VehicleFilterCheckbox



// WEBPACK FOOTER //
// ./components/VehicleFilterCheckbox/VehicleFilterCheckbox.jsx